import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TdLoadingService } from '@covalent/core/loading';
import { subMinutes } from 'date-fns';
import { TypedFormBuilder, TypedFormGroup } from 'formsafe';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import {
  cannotCreateMultipleOpenShifts,
  dutyTimeExceeds14Hours,
  endTimeMustBeGreaterThanStartTime,
  endTimeMustNotExeed30MinutesFromNow,
  justificationRequiredForDutyTimesExceeding14Hours,
  startTimeMustNotExeed30MinutesFromNow,
} from 'src/app/duty-logs/duty-log-form-validators';
import { DutyLogHttpClient } from 'src/app/shared/flight-log-api/duty-logs/duty-log-client.service';
import { CreateDutyLogParams } from 'src/store/duty-log/duty-log.model';
import { getValueChanges } from 'src/util/angular/ng-forms-helpers';
import { field, getValidationErrorsChangesDeep } from 'src/util/angular/ng-forms-validation';
import { kendoDateTime24HourFormat } from 'src/util/dateLib';
import { UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-duty-edit-retro-page',
  templateUrl: './duty-edit-retro-page.component.html',
  styleUrls: ['./duty-edit-retro-page.component.scss'],
})
export class DutyEditRetroPageComponent implements OnInit {
  public loadingKey = 'duty-edit-retro-form';
  public form: TypedFormGroup<CreateDutyLogParams>;
  public errors$: Observable<string[]>;
  public dutyTimeExceeds14Hours$: Observable<boolean>;
  public dateTimeFormat = kendoDateTime24HourFormat;

  constructor(
    @Inject(USER) private _user: UserViewModel,
    private _loading: TdLoadingService,
    private _dutyLogHttpClient: DutyLogHttpClient,
    private _router: Router,
    private _fb: TypedFormBuilder,
  ) {}

  public ngOnInit() {
    this.form = this._fb.group<CreateDutyLogParams>(
      {
        baseId: [undefined, field('Base', { required: true })],
        aircraftId: [undefined, field('Aircraft', { required: true })],
        employeeId: [this._user.id, field('Employee', { required: true })],
        dutyPeriodStartTime: [
          subMinutes(new Date(), 1),
          field('Duty on time', {
            required: true,
            validators: [startTimeMustNotExeed30MinutesFromNow],
          }),
        ],
        dutyPeriodEndTime: [
          new Date(),
          field('Duty off time', {
            required: !this._user.isAviationSupervisor,
          }),
        ],
        comments: [undefined],
        justification: [undefined],
        restJustification: [undefined],
      },
      {
        validators: [
          justificationRequiredForDutyTimesExceeding14Hours,
          endTimeMustBeGreaterThanStartTime,
          endTimeMustNotExeed30MinutesFromNow,
        ],
        asyncValidators: [cannotCreateMultipleOpenShifts(this._dutyLogHttpClient)],
      },
    );

    this.dutyTimeExceeds14Hours$ = getValueChanges(this.form).pipe(map(dutyTimeExceeds14Hours));
    this.errors$ = getValidationErrorsChangesDeep(this.form);
  }

  public async create() {
    this._loading.register(this.loadingKey);
    try {
      await this._dutyLogHttpClient.create(this.form.value).toPromise();
      this._router.navigate(['duty-logs']);
    } catch (err) {
      throw err;
    } finally {
      this._loading.resolveAll(this.loadingKey);
    }
  }
}
